// extracted by mini-css-extract-plugin
export default {"root":"Indicator_root__b1dJG","dot":"Indicator_dot__tfL80","currentDot":"Indicator_currentDot__Inhgx"};